import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import dayjs from 'dayjs';
import {
  HIGHCHARTS_DATETIME_FORMATS,
  type HighchartsDateTimeFormatType,
  PARTIAL_DATE_FORMATS,
  type PartialDateFormatType,
} from 'lumen/utils/constants/general-constants';

export type SupportedLocale =
  | 'de'
  | 'en'
  | 'en-gb'
  | 'es'
  | 'fr'
  | 'it'
  | 'ja'
  | 'nl'
  | 'pt-br'
  | 'zh-tw';

export default class DatesService extends Service {
  @tracked locale: SupportedLocale = 'en-gb';
  @tracked startOfWeek?: string;

  get highchartsLabelFormats(): HighchartsDateTimeFormatType {
    return HIGHCHARTS_DATETIME_FORMATS[this.locale];
  }

  get partialDateFormat(): PartialDateFormatType {
    return PARTIAL_DATE_FORMATS[this.locale];
  }

  setLocale(locale: SupportedLocale): void {
    dayjs.locale(locale);

    this.locale = locale;

    // `startOfWeek` must be updated after `locale`
    this.startOfWeek = dayjs.localeData().firstDayOfWeek().toString();
  }
}

declare module '@ember/service' {
  interface Registry {
    dates: DatesService;
  }
}
